import {
  Container,
  ContainerIcon,
  ContainerImg,
  DocumentName,
  Image,
} from "../style/style";
import { NB_DocumentCardProps } from "../types/documentCard.type";
import { NbContextMenu } from "../../contexMenu/contextMenu";

export const DocumentCardView = (props: Partial<NB_DocumentCardProps>) => {
  return (
    <Container>
      <ContainerIcon>
        <NbContextMenu
          hideList
          listItem={props.listContextMenu}
          onClickItemList={(e) => {
            if (props.onClickItemList) {
              props.onClickItemList(e);
            }
          }}
        />
      </ContainerIcon>
      <ContainerImg>
        <Image src={props.iconImg} alt="Doc" />
      </ContainerImg>

      <DocumentName>{props.fileName}</DocumentName>
    </Container>
  );
};

//4871582
